var map = {
	"./default/view": 354,
	"./phapa/view": 1099,
	"./special-events/view": 1103
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1251;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/pages ^\.\/.*\/view$
// module id = 1251
// module chunks = 0